import type { Project } from "@/openapi";

const LAST_OPENED_PREFIX = "auditor:last-opened-dossier:";

export function rememberLastOpenedDossier(
  clientKey: string,
  dossier: Project,
): void {
  try {
    localStorage.setItem(LAST_OPENED_PREFIX + clientKey, dossier.id);
  } catch {
    // storage unavailable (private mode); default-to-latest still works
  }
}

export function lastOpenedDossierId(clientKey: string): string | null {
  try {
    return localStorage.getItem(LAST_OPENED_PREFIX + clientKey);
  } catch {
    return null;
  }
}
